import {
  call,
  put,
  select,
  takeEvery,
  takeLatest
} from '@redux-saga/core/effects';
import { ActionType } from 'typesafe-actions';

import * as Actions from '../actions/accountAction';
import * as Apis from '../apis/accountApi';
import * as Models from '../models/accountModel';

function* register(action: ActionType<typeof Actions.register.request>) {
  try {
    const { data, agreeTerms } = action.payload;

    const res = yield call(Apis.accountApi.register, { data, agreeTerms });

    const resData = res.data;

    if (resData.errrCode > 0) {
      yield put(Actions.register.success(resData));
    } else {
      yield put(Actions.register.failure(resData));
    }
  } catch (error) {
    yield put(Actions.register.failure(error));
    //   yield put(Actions.createNoticeAction.failure(error));
  }
}

function* temrsList(action: ActionType<typeof Actions.termsList.request>) {
  try {
    const { langDivCd, siteCd } = action.payload;

    const res = yield call(Apis.accountApi.temrsList, { langDivCd, siteCd });

    const resData: Models.AccountTermsData[] = res.data;

    yield put(Actions.termsList.success(resData));
  } catch (error) {
    yield put(Actions.termsList.failure(error));
    //   yield put(Actions.createNoticeAction.failure(error));
  }
}

export function* accountSaga() {
  yield takeEvery(Actions.register.request, register);
  yield takeEvery(Actions.termsList.request, temrsList);
}
